import React from "react";
import type { Control, FieldValues, UseControllerProps } from "react-hook-form";
import { useController } from "react-hook-form";

import type { NumberInputProps } from "@braintrust/braintrust-ui-components";
import { NumberInput } from "@braintrust/braintrust-ui-components";

export type RhfNumberFieldProps<T extends FieldValues> = UseControllerProps<T> &
  NumberInputProps & {
    control: Control<T>;
    unsetOnEmpty?: boolean;
  };

/** @description operates on string, you can transform value on submit if needed */
export const RhfNumberField = <T extends FieldValues>({
  helperText,
  unsetOnEmpty = true,
  ...props
}: RhfNumberFieldProps<T>) => {
  const { field, fieldState } = useController(props);

  return (
    <NumberInput
      {...props}
      {...field}
      onChange={(value) => {
        props.onChange?.(value);
        if (unsetOnEmpty && value === "") {
          // set to default value to avoid `dirty` state
          field.onChange(undefined);
        } else {
          field.onChange(value);
        }
      }}
      ref={undefined}
      error={fieldState.invalid}
      helperText={fieldState.error?.message || helperText}
    />
  );
};
